import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6 .25a.75.75 0 0 1 .75.75v4.25h4.251l.076.003a.75.75 0 0 1 0 1.493l-.076.004H6.75V11l-.004.077a.75.75 0 0 1-1.492 0L5.25 11V6.75H1a.75.75 0 1 1 0-1.5h4.25V1A.75.75 0 0 1 6 .25" }, null, -1)
  ]))]))
}
export default { render: render }